import React, { useState, useEffect } from 'react'
import { Form, Checkbox as SemanticCheckbox } from 'semantic-ui-react';
import PropTypes from "prop-types";

const Checkbox = ({ onChange, value: propValue, label, ...rest }) => {
    const [value, setValue] = useState(!!propValue);

    useEffect(() => {
        setValue(propValue);
    }, [propValue]);

    const onCheckboxChange = (e, {checked}) => {
        setValue(checked);
        onChange?.(checked);
    }

    return (
        <Form.Field key="Active" {...rest}>
            <label>{label}</label>
            <SemanticCheckbox
                onChange={onCheckboxChange}
                checked={value}
                {...rest}
            />
        </Form.Field>
    )
}

Checkbox.propTypes = {
    onChange: PropTypes.func,
    value: PropTypes.bool,
    label: PropTypes.string,
}

export default Checkbox;